// AUTO-GENERATED Tue Dec 03 2024 14:35:26 GMT+0100 (GMT+01:00) do not edit or replace
export const EVA_API_VERSION = 767;
//# sourceMappingURL=api-version.js.map